import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import Modal from '../../modal'
import Divider from '../../divider'
import SignatureRequestStatus from '../../../queries/SignatureRequestStatus'
import { useMutation } from '@apollo/react-hooks'
import { EsignVendors } from '../../constants'
import { getSignersStatus } from '../../../helpers/DocuSignUtil'

const ContainerElement = styled.div`
  display: grid;
  grid-template-columns: 3fr 5fr 1fr 1fr;
  align-items: center;
  width: 55rem;
  margin-bottom: 1rem;
`

const ColumnHeaderElement = styled.p`
  font-weight: bold;
  font-size: 0.9rem;
  margin: 0;
`

const TextElement = styled.p`
  font-weight: 200;
  font-size: 0.9rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
`

const DividerWrapper = styled.div`
  grid-column: span 4;
`

const SignerStatuses = {
  delivered: 'delivered',
  completed: 'completed',
}

function StatusModal({
  esignVendor,
  docusignServiceBaseUrl,
  documentKey,
  documentId,
  onClose,
}) {
  const [loading, setLoading] = useState(true)
  const [signatureRequests, setSignatureRequests] = useState([])

  const onCompleted = (signersStatus) => {
    setLoading(false)
    setSignatureRequests(
      signersStatus?.signatureRequestStatus?.helloSignSignatures ||
        signersStatus?.signers,
    )
  }

  const onError = () => setLoading(false)

  // for some reason, the this is a mutation instead of a query
  const [getSignatureRequestStatus] = useMutation(SignatureRequestStatus, {
    onCompleted,
    onError,
  })

  useEffect(() => {
    if (esignVendor === EsignVendors.DocuSign) {
      getSignersStatus(
        docusignServiceBaseUrl,
        documentKey,
        onCompleted,
        onError,
      )
    } else {
      getSignatureRequestStatus({
        variables: {
          input: {
            documentId,
          },
        },
      })
    }
  }, [])

  return (
    <Modal title="eSign status" onClose={onClose}>
      <Divider />
      <ContainerElement>
        <ColumnHeaderElement>Signer</ColumnHeaderElement>
        <ColumnHeaderElement>Email</ColumnHeaderElement>
        <ColumnHeaderElement>Viewed</ColumnHeaderElement>
        <ColumnHeaderElement>Signed</ColumnHeaderElement>
        <DividerWrapper>
          <Divider />
        </DividerWrapper>
        {loading && (
          <DividerWrapper>
            <TextElement style={{ textAlign: 'center' }}>
              Loading...
            </TextElement>
          </DividerWrapper>
        )}
        {signatureRequests.map(({ name, email, viewed, signed, status }) => (
          <React.Fragment key={`${name}-${email}`}>
            <TextElement>{name}</TextElement>
            <TextElement>{email}</TextElement>
            <TextElement>
              {viewed || Object.values(SignerStatuses).includes(status)
                ? '✔️'
                : '❌'}
            </TextElement>
            <TextElement>
              {signed || status === SignerStatuses.completed ? '✔️' : '❌'}
            </TextElement>
          </React.Fragment>
        ))}
        <DividerWrapper>
          <Divider />
        </DividerWrapper>
      </ContainerElement>
    </Modal>
  )
}

export default StatusModal
